// FNP-217: form-shape Zod schema for MeterAssignment (mirrors the meters module,
// which moved from a Yup parallel schema to Zod in FNP-58).
// Required: customerId, meterId, channel, channelIdentifiers (valid JSON object),
// status, effectiveFrom. freeTierQuantity / committedQuantity / effectiveTo are
// optional.
import {z} from 'zod';

// channelIdentifiers is edited in the form as a JSON text string (textarea). It
// must parse to a JSON object — { subscriptionItemId } for STRIPE, or
// { customerIdentifier, dimension } for AWS_MARKETPLACE. Accept an already-parsed
// object too, in case the form value was hydrated from a read.
const channelIdentifiersSchema = z.union([
    z.string().refine((val) => {
        try {
            const parsed = JSON.parse(val);
            return parsed !== null && typeof parsed === 'object' && !Array.isArray(parsed);
        } catch {
            return false;
        }
    }, 'Must be a valid JSON object'),
    z.record(z.unknown()),
]);

export const RecordSchema = z.object({
    customerId: z.string().min(1, 'Required'),
    meterId: z.string().min(1, 'Required'),
    channel: z.string().min(1, 'Required'),
    channelIdentifiers: channelIdentifiersSchema,
    freeTierQuantity: z.coerce.number().nonnegative().optional(),
    committedQuantity: z.coerce.number().nonnegative().optional(),
    status: z.string().min(1, 'Required'),
    effectiveFrom: z.string().min(1, 'Required'),
    effectiveTo: z.string().optional(),
});
